module.exports = __webpack_public_path__ + "static/media/mewahtranscover2.379e1f67.jpg";